module.exports = __webpack_public_path__ + "img/geographicalDistributions.8e2bcb08.svg";